import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import MobileNavigationBar from "../components/mobileNavbar";
import ZakatChart from "../components/zakatchart";
import MobileMasjidLogos from "../components/mobileMasjidLogos";
import MobileFooter from "../components/mobileFooter";
import greenBanner from "../assets/greenbanner.png";
import { MdFamilyRestroom } from "react-icons/md";
import { FaWheelchair } from "react-icons/fa";
import { GiReceiveMoney } from "react-icons/gi";
import { RiHeartsFill } from "react-icons/ri";
import { GiHandcuffs } from "react-icons/gi";
import { FaMoneyBillWave } from "react-icons/fa";
import { BsMoonStars } from "react-icons/bs";
import { IoFootstepsSharp } from "react-icons/io5";
import testimonials from "../components/testimonials";

const iconComponents = [
  <MdFamilyRestroom />,
  <FaWheelchair />,
  <GiReceiveMoney />,
  <RiHeartsFill />,
  <GiHandcuffs />,
  <FaMoneyBillWave />,
  <BsMoonStars />,
  <IoFootstepsSharp />,
];

const categories = [
  "Families in Need",
  "People With Special Needs",
  "Zakat Administrators",
  "Reconciled Hearts",
  "Captives",
  "Debt Ridden",
  "Fi-SibillAllah",
  "Wayfarer",
];

export const MobileHomePage = () => {
  return (
    <div className="home-page">
      <MobileNavigationBar />

      <div
        style={{
          backgroundImage: `url(${greenBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          fontFamily: "Lora, serif",
        }}
      >
        <Container className="px-3 py-3 text-center">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: ".5rem",
            }}
          >
            <div >
              <div style={{ fontSize: 24, fontWeight: "700", marginBottom: "0.5rem" }}>
                Greater Austin Muslim Relief Committee:
              </div>
              <div style={{ fontSize: 18, fontWeight: "600", }}>
                A Unified Zakah Committee Nurturing Communities in The Greater Austin Area
              </div>
            </div>

            <div style={{ minWidth: "280px", display: "flex", flexDirection: "column" }}>
              <p style={{ fontSize: 16, lineHeight: 1.5, textAlign: "justify", marginBottom: "1.5rem" }}>
                The Greater Austin Muslim Relief Committee (GAMRC) is dedicated to providing
                financial and humanitarian assistance to community members in need. We serve
                all 8 categories of Zakat, as outlined in Surah At-Tawbah:
                the poor, the needy, Zakat administrators, reconciled hearts, captives,
                dept ridden , Fi-SibillAllah, and travelers in need.
              </p>

              <div style={{ display: "flex", gap: "1rem" }}>
                <Button href="/ApplyForHelp" className="nav-button apply-button">
                  Apply For Help
                </Button>

                <Button href="/PayZakatHere" className="nav-button zakat-button">
                  Pay Zakat
                </Button>
              </div>
            </div>
          </div>
        </Container>
      </div>
       <div
        style={{
          backgroundColor: "#BF5700",
          color: "white",
          padding: "6px 12px",
          textAlign: "center",
          fontSize: "18px",
          fontWeight: "600",
        }}
      >
        <a
          href="/Eid-Al-Adha"
          style={{
            color: "white",
            textDecoration: "none",
          }}
        >
          Eid-Al-Adha Qurbani - More Info →
          </a>
      </div>

      <Container className="my-3">
        <div className="text-center my-2 mx-2">
          <h4>United for the good of humanity and the good of our community (Muslims and non-Muslims)</h4>
          <div className="text-center my-2 px-2 py-1" style={{ backgroundColor: '#D4C5E4', borderRadius: '10px' }}>
            <p style={{ fontSize: "16px" }}>
              The Greater Austin Muslim Relief Committee is NOT an organization. We are a unified committee of the local Austin masajid.
              You can pay your Zakat at the masajid linked below. The Zakat will be distributed through GAMRC to those in need.
            </p>
          </div>
        </div>
        <hr style={{ height: "2px", backgroundColor: "black" }} />
        <div className=" text-center justify-content-center">
          <Row className="align-items-center">
            <Col xs="auto">
              <h4 style={{ whiteSpace: 'nowrap' }}>Where does the Zakat go?</h4>
            </Col>
            <Col xs="auto" className="d-flex justify-content-end">
              <Button
                href="/HowItWorks"
                style={{
                  backgroundColor: "#42226D",
                  borderColor: "#42226D",
                  fontSize: '14px',
                  fontWeight: 'bold',
                  fontFamily: 'Lora',
                  width: 'auto'
                }}
              >
                How It Works
              </Button>
            </Col>
          </Row>
        </div>
        <div className="d-flex justify-content-center" style={{ height: '250px', width: '100%' }}>
          <ZakatChart className='mb-2' />
        </div>
        <hr style={{ height: "2px", backgroundColor: "black" }} />

        <div className=" my-2 px-2 py-1">
          <Row className="align-items-center justify-content-between text-center">
            <Col xs={12} md={8} className="text-md-start mb-2 ">
              <h4 style={{ fontSize: '16px' }}>
                Quick Links:
              </h4>

            </Col>
            <Container className="my-2">
              <Row className="g-3 justify-content-center text-center">
                <Col xs={6} sm={6} md={4} lg={3}>
                  <Button
                    href="/whatwedo"
                    style={{
                      backgroundColor: "#42226D",
                      fontSize: '14px',
                      fontWeight: 'bold',
                      fontFamily: 'Lora',
                      width: '100%',
                      maxWidth: '200px',
                      outline: 'none',
                      borderColor: "#42226D"
                    }}
                  >
                    What We Do
                  </Button>
                </Col>
                <Col xs={6} sm={6} md={4} lg={3}>
                  <Button
                    href="/howitworks"
                    style={{
                      backgroundColor: "#42226D",
                      fontSize: '14px',
                      fontWeight: 'bold',
                      fontFamily: 'Lora',
                      width: '100%',
                      maxWidth: '200px',
                      outline: 'none',
                      borderColor: "#42226D"
                    }}
                  >
                    How It Works
                  </Button>
                </Col>
                <Col xs={6} sm={6} md={4} lg={3}>
                  <Button
                    href="/nonmuslims"
                    style={{
                      backgroundColor: "#42226D",
                      fontSize: '14px',
                      fontWeight: 'bold',
                      fontFamily: 'Lora',
                      width: '100%',
                      maxWidth: '200px',
                      outline: 'none',
                      borderColor: "#42226D"
                    }}
                  >
                    Non-Muslims Relief
                  </Button>
                </Col>
                <Col xs={6} sm={6} md={4} lg={3}>
                  <Button
                    href="/faq"
                    style={{
                      backgroundColor: "#42226D",
                      fontSize: '14px',
                      fontWeight: 'bold',
                      fontFamily: 'Lora',
                      width: '100%',
                      maxWidth: '200px',
                      outline: 'none',
                      borderColor: "#42226D"
                    }}
                  >
                    FAQ
                  </Button>
                </Col>
                <Col xs={6} sm={6} md={4} lg={3}>
                  <Button
                    href="/musallah"
                    style={{
                      backgroundColor: "#42226D",
                      fontSize: '14px',
                      fontWeight: 'bold',
                      fontFamily: 'Lora',
                      width: '100%',
                      maxWidth: '200px',
                      outline: 'none',
                      borderColor: "#42226D"
                    }}
                  >
                    Musallah
                  </Button>
                </Col>
              </Row>
            </Container>

          </Row>
          <hr style={{ height: "2px", backgroundColor: "black" }} />
        </div>
        <div className="text-center  my-2 px-2 py-0">
          <h4 style={{ fontSize: '16px' }}>Voices From The Community</h4>
          <Row className="g-3">
            {testimonials.slice(0, 1).map((t, i) => (
              <Col key={i} md={4}>
                <div
                  style={{
                    backgroundColor: "#D4DFCB",
                    borderRadius: "12px",
                    padding: "20px",
                    minHeight: "180px",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    color: "#1b2e1bff",
                    fontStyle: "italic",
                  }}
                  href="/Testimonials"
                >
                  <div>“{t.quote}”</div>
                  <div style={{ alignSelf: "flex-end", fontStyle: "normal", fontWeight: "600", marginTop: "10px" }}>
                    — {t.name}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
            <a
              href="/Testimonials"
              style={{
                textDecoration: "none",
                color: "#1b2e1bff",
                fontWeight: "500",
                fontSize: "16px"
              }}
            >
              See more →
            </a>
          </div>
          <hr style={{ height: "2px", backgroundColor: "black" }} />

        </div>
        <p style={{ fontSize: "16px" }} className="text-center my-2">
          Donate <a href="/PayZakatHere">here</a> or give your Zakat through Austin-area masajid to
          help strengthen your community.
        </p>
        <MobileMasjidLogos />
        <p style={{ fontSize: "16px" }} className="text-center my-2">
          JazakAllah Khair to our most generous communities at Nueces Mosque, ICBC and ICGA</p>


        <hr style={{ height: "2px", backgroundColor: "black" }} />
        {/* Quranic Verse */}
        <h4 style={{ color: "#31572C" }} className="text-center my-2 mx-2">
          إِنَّمَا الصَّدَقَاتُ لِلْفُقَرَاءِ وَالْمَسَاكِينِ وَالْعَامِلِينَ عَلَيْهَا وَالْمُؤَلَّفَةِ قُلُوبُهُمْ وَفِي الرِّقَابِ وَالْغَارِمِينَ وَفِي سَبِيلِ اللَّهِ وَابْنِ السَّبِيلِ فَرِيضَةً مِّنَ اللَّهِ وَاللَّهُ عَلِيمٌ حَكِيمٌ
        </h4>
        <p className="text-center pb-1" style={{ fontSize: "14px" }}>
          "Zakat expenditures are only for the poor and for the needy and for those employed to collect [zakat] and for
          bringing hearts together [for Islam] and for freeing captives and for those in debt and for the cause of Allah
          and for the [stranded] traveler. This is an obligation from Allah, and Allah is All-Knowing, All-Wise." (9:60)
        </p>

        <div className="d-flex justify-content-center">
          <Col xs={12}>
            <Row className="g-0 h-100">
              {categories.map((category, idx) => (
                <Col key={idx} xs={6} md={3}>
                  <div
                    className="d-flex flex-column align-items-center justify-content-center text-center h-100 w-100 p-2"
                    style={{
                      borderRadius: "10px",
                      height: "150px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div style={{ fontSize: "32px", color: "#31572C", marginBottom: "0.5rem" }}>
                      {iconComponents[idx]}
                    </div>
                    <div style={{ fontSize: "16px", fontWeight: "500" }}>{category}</div>
                  </div>
                </Col>
              ))}
              <p className="mt-2" style={{ fontSize: '12px', textAlign: 'center' }}>Although Zakat administrators are eligible to receive from Zakat funds, all of our
                volunteers serve purely out of goodwill and for the sake of Allah. Please keep them in your duas.</p>
            </Row>
          </Col>
        </div>
      </Container>

      <MobileFooter />
    </div>
  );
};


export default MobileHomePage;
